import { styled } from 'baseui'

export const ReminderStack = styled('section', {
  position: 'fixed',
  top: '1rem',
  right: '1rem',
  zIndex: 1150,
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  width: '22rem',
  maxWidth: 'calc(100vw - 2rem)',
  maxHeight: 'calc(100vh - 9rem)',
  overflowY: 'auto',
})
